"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  actionOutput: 'Action Output',
  actionUsedQualifications: 'Action Used Qualifications',
  cancel: 'Cancel',
  close: 'Close',
  closeGodModeQuestion: 'Do you want to stop testing?',
  closeGodModeWindow: 'This will close this tab',
  columnMenuFilter: 'Filter',
  columnMenuHideColumn: 'Hide column',
  columnMenuLabel: 'Menu',
  columnMenuManageColumns: 'Manage columns',
  columnMenuShowColumns: 'Show columns',
  columnMenuSortAsc: 'Sort by ASC',
  columnMenuSortDesc: 'Sort by DESC',
  columnMenuUnsort: 'Unsort',
  columnsPanelDragIconLabel: 'Reorder column',
  columnsPanelHideAllButton: 'Hide all',
  columnsPanelShowAllButton: 'Show all',
  columnsPanelTextFieldLabel: 'Find column',
  columnsPanelTextFieldPlaceholder: 'Column title',
  conditionActionExecutionTime: 'Condition/Action execution time',
  conditionOutput: 'Condition Output',
  conditionQualifications: 'Condition Qualifications',
  consultantNr: 'Consultant Nr.',
  filterAllXValue: 'All ({value})',
  filterErrorsXValue: 'Errors ({value})',
  filterOperatorAfter: 'is after',
  filterOperatorBefore: 'is before',
  filterOperatorContains: 'contains',
  filterOperatorEndsWith: 'ends with',
  filterOperatorEquals: 'equals',
  filterOperatorIs: 'is',
  filterOperatorIsAnyOf: 'is any of',
  filterOperatorIsEmpty: 'is empty',
  filterOperatorIsNotEmpty: 'is not empty',
  filterOperatorNot: 'is not',
  filterOperatorOnOrAfter: 'is on or after',
  filterOperatorOnOrBefore: 'is on or before',
  filterOperatorStartsWith: 'starts with',
  filterOptions: 'Filter',
  filterPanelAddFilter: 'Add filter',
  filterPanelColumns: 'Columns',
  filterPanelDeleteIconLabel: 'Delete',
  filterPanelInputLabel: 'Value',
  filterPanelInputPlaceholder: 'Filter value',
  filterPanelLogicOperator: 'Logic operator',
  filterPanelOperator: 'Operator',
  filterPanelOperatorAnd: 'And',
  filterPanelOperatorOr: 'Or',
  filterPanelRemoveAll: 'Remove all',
  filterQualifiedXValue: 'Qualified ({value})',
  filterUsedXValue: 'Used ({value})',
  godModeBarTitle: 'Rules Testing Output - God Mode Bar',
  moment: 'Moment',
  noData: 'No data',
  noRulesAvailable: 'No rules available',
  period: 'Period',
  ruleDescription: 'Rule Description',
  ruleId: 'Rule ID',
  ruleSet: 'Rule Set',
  ruleType: 'Rule Type',
  toolbarColumns: 'Columns',
  toolbarDensity: 'Density',
  toolbarDensityComfortable: 'Comfortable',
  toolbarDensityCompact: 'Compact',
  toolbarDensityStandard: 'Standard',
  toolbarExport: 'Export',
  toolbarExportCSV: 'Download as CSV',
  toolbarExportExcel: 'Download as Excel',
  toolbarExportPrint: 'Print',
  toolbarFilters: 'Filters',
  toolbarFiltersTooltipActiveOne: 'One active filter',
  toolbarFiltersTooltipActiveXValue: '{value} active filters',
  toolbarFiltersTooltipHide: 'Hide filters',
  toolbarFiltersTooltipShow: 'Show filters',
  toolbarSelectColumns: 'Select columns',
  toolbarShowFilters: 'Show filters'
};
const translationsNamespace = exports.translationsNamespace = 'checkout-godmode';